import { SearchBarProps } from "../types";

export function getDefaults(props: SearchBarProps) {
  return {
    placeholder: props.placeholder || "Search...",
    trigger: props.trigger || "manual",
    debounceMs: props.debounceMs || 500,
    triggerInstantOnClear: props.triggerInstantOnClear ?? true,
    urlParamStrategy: props.urlParamStrategy || "direct",
    className: props.className || "",
    loading: props.loading || false,
    disabled: props.disabled || false,
    
    fieldSelector: props.fieldSelector || {
      enabled: false,
      fields: [],
      allowAll: false,
      defaultValue: "all"
    },
    
    clearButton: {
      enabled: props.clearButton?.enabled ?? true,
      position: props.clearButton?.position || "inside",
      ariaLabel: props.clearButton?.ariaLabel || "Clear search",
      icon: props.clearButton?.icon
    },
    
    submitButton: {
      label: props.submitButton?.label || "Search",
      ariaLabel: props.submitButton?.ariaLabel || "Search",
      icon: props.submitButton?.icon
    },
    
    validation: props.validation,
    onSearchChange: props.onSearchChange,
    onClear: props.onClear
  };
}

